
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkTenantApiKey } from '../models/work-tenant-api-key';

export function getCreateTenantApiKeyResponseDtoFormGroup() {
return new FormGroup({
    apiKey: new FormControl<WorkTenantApiKey | undefined>(undefined, [Validators.required]),
    plainKey: new FormControl<string | undefined>('', [Validators.required]),
})
;
}
      